import { AircraftIcon } from '@icons';
import { Button, Tooltip } from '@ds';
import { AirportListItemType } from '@lp/features/RoutePlanner/types';
import { RecommendedFlightType } from '@/api/apis/route';
import { CommercialFlightInfo } from './CommercialFlightInfo';

type RecommendedFlightProps = {
  selectedFlightId: string | null;
  departureAirport: AirportListItemType | null;
  arrivalAirport: AirportListItemType | null;
  flight: RecommendedFlightType;
  onFlightSelect: (flight: RecommendedFlightType) => void;
};

export const RecommendedFlight = ({
  departureAirport,
  arrivalAirport,
  selectedFlightId,
  flight,
  onFlightSelect,
}: RecommendedFlightProps) => {
  const handleFlightSelect = () => {
    onFlightSelect(flight);
  };

  return (
    <div
      className="grid py-2 bg-base-90 rounded-lg"
      style={{
        gridTemplateColumns: '1fr 4fr 7fr 4fr 2fr 2fr',
        gridTemplateRows: '1fr',
      }}
    >
      <div className="flex items-center justify-center text-base-5">
        <AircraftIcon />
      </div>
      <div className="flex items-center px-3">
        <Tooltip content={flight.flightOperator} delay={0} closeDelay={0}>
          <span className="w-40 text-s-sb text-base-5 truncate">{flight.flightOperator}</span>
        </Tooltip>
      </div>
      <CommercialFlightInfo departureAirport={departureAirport} arrivalAirport={arrivalAirport} flight={flight} />
      <div className="flex items-center px-3 justify-end">
        <span className="text-s-sb text-base-5">{`${flight.ticketType} $${Math.round(flight.price)}`}</span>
      </div>
      <div className="flex items-center px-3">
        <span className="text-s-sb text-base-5">{`${flight.numberOfSeats} seats`}</span>
      </div>
      <div className="flex items-center justify-center">
        <Button size="sm" variant="outline" isDisabled={selectedFlightId === flight.id} onPress={handleFlightSelect}>
          {selectedFlightId === flight.id ? 'Selected' : 'Select'}
        </Button>
      </div>
    </div>
  );
};
